<app-header></app-header>

<div class="view-editor" *ngIf="view">
  <div class="editor-header">
    <div class="editor-title">
      <button class="button" (click)="back()">&larr; Views</button>
      <h1>{{isNew ? 'New View' : view.name}}</h1>
      <span class="inactive-badge" *ngIf="view.active === false">Inactive</span>
    </div>
    <div class="editor-actions">
      <button class="button red" *ngIf="!isNew && view.active !== false" (click)="deactivate()">Deactivate</button>
      <button class="button" [disabled]="saving" (click)="save()">{{isNew ? 'Create View' : 'Save View'}}</button>
    </div>
  </div>

  <app-tabs>
    <app-tabpage title="General">
      <div class="form-grid">
        <label>
          Name
          <input type="text" placeholder="view name" [(ngModel)]="view.name" />
        </label>
        <label>
          Key
          <input type="text" placeholder="auto-generated when blank" [(ngModel)]="view.key" />
        </label>
        <label>
          Collection
          <input type="text" placeholder="MongoDB collection" [(ngModel)]="view.collection" />
        </label>
      </div>

      <div class="flag-row">
        <label class="flag">
          <app-toggle [checked]="view.active !== false" (valueChanged)="view.active = $event"></app-toggle>
          Active
        </label>
        <label class="flag">
          <app-toggle [checked]="!!view.importable" (valueChanged)="view.importable = $event"></app-toggle>
          Importable
        </label>
        <label class="flag">
          <app-toggle [checked]="!!view.creatable" (valueChanged)="view.creatable = $event"></app-toggle>
          Creatable
        </label>
      </div>

      <p class="hint" *ngIf="view.key">
        Permissions for this view: view.{{view.key}}.view, view.{{view.key}}.update, view.{{view.key}}.import, view.{{view.key}}.create, view.{{view.key}}.delete
      </p>
    </app-tabpage>

    <app-tabpage title="Fields">
      <div class="section-header">
        <h3>Fields</h3>
        <button class="button" (click)="addField()">Add Field</button>
      </div>

      <app-field-editor *ngFor="let field of view.fields; let i = index"
        [field]="field" mode="view" [index]="i" [count]="view.fields.length"
        (remove)="removeField(i)" (moveUp)="moveField(i, -1)" (moveDown)="moveField(i, 1)">
      </app-field-editor>

      <div class="section-header">
        <h3>Active Fields</h3>
      </div>
      <p class="hint">Fields displayed by default when the view loads.</p>
      <div class="active-field-list">
        <label class="flag" *ngFor="let field of view.fields">
          <input type="checkbox" [checked]="isActiveField(field.path)"
            (change)="toggleActiveField(field.path, $event.target.checked)" />
          {{field.name || field.path}}
        </label>
        <label class="flag orphan" *ngFor="let path of orphanedActiveFields">
          <input type="checkbox" checked (change)="toggleActiveField(path, $event.target.checked)" />
          {{path}} (no matching field)
        </label>
      </div>
    </app-tabpage>

    <app-tabpage title="Filters">
      <div class="section-header">
        <h3>View Filters</h3>
      </div>
      <p class="hint">Documents must match these criteria to be loaded or imported through this view.</p>
      <app-filter-editor [(filters)]="view.filters"></app-filter-editor>
    </app-tabpage>

    <app-tabpage title="Actions &amp; Import">
      <div class="section-header">
        <h3>Actions</h3>
        <button class="button" (click)="addAction()">Add Action</button>
      </div>
      <p class="hint">Action buttons shown on the detail view, e.g. delete.</p>
      <div class="action-row" *ngFor="let action of view.actions; let i = index">
        <input type="text" placeholder="action key, e.g. delete" [(ngModel)]="action.key" />
        <input type="text" placeholder="display name (optional)" [(ngModel)]="action.name" />
        <input type="text" placeholder="custom route (optional)" [(ngModel)]="action.route" />
        <button class="button small red" (click)="removeAction(i)">Remove</button>
      </div>

      <div class="section-header">
        <h3>Import Match Fields</h3>
      </div>
      <p class="hint">Imported rows are matched to existing documents using these fields.</p>
      <div class="active-field-list">
        <label class="flag" *ngFor="let field of view.fields">
          <input type="checkbox" [checked]="isImportMatchField(field.path)"
            (change)="toggleImportMatchField(field.path, $event.target.checked)" />
          {{field.name || field.path}}
        </label>
      </div>
    </app-tabpage>
  </app-tabs>
</div>

<app-support *ngIf="supportActive"></app-support>
<app-settings *ngIf="settingsActive"></app-settings>
